import { Spinner } from 'reactstrap';
import { getTimeString } from '@/shared/lib/aiUtils';
import usePDFLoading from './usePDFLoading';

export type PDFLoadingProps = {
  isRendering?: boolean;
};

/**
 * Covers the PDF report area while a report is being rendered or downloaded. Renders a spinner plus either a rendering message or the download percentage and estimated time left, both taken from the PDF loading hook.
 *
 * @param isRendering - Whether the report is still being rendered rather than downloaded.
 * @returns The rendered PDF loading panel with its spinner and progress text.
 */
const PDFLoading = ({ isRendering }: PDFLoadingProps) => {
  const { progressDownload, estimateDownload } = usePDFLoading();

  return (
    <div className="pdf-loading-container">
      <Spinner className="pdf-loading__spinner">
        {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
        {''}
      </Spinner>
      <div className="pdf-loading__text">
        {isRendering ? (
          'Rendering report...'
        ) : (
          <>
            <div>{`Downloading report: ${Math.round(progressDownload * 100)}%`}</div>
            <div>{`Estimated time left: ${getTimeString(estimateDownload)}`}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default PDFLoading;
